import { FC } from 'react';
import DocumentManagementButton from 'components/organisms/DocumentManagementButton';
import AlfredTableTemplate from 'components/template/AlfredTableTemplate';
import ConfirmModal from 'components/molecules/ConfirmModal';
import { useDocumentList } from './resources/useDocumentList';

const DocumentListScreen: FC = () => {
  const {
    data,
    columns,
    deleteModalTitle,
    deleteModalText,
    deleteModalMainButtonText,
    deleteModalSecondaryButtonText,
    pageCurrent,
    pageSize,
    totalPages,
    onSave,
    onRefresh,
    onRowClick,
    onConfirmDeleteDocument,
    onCloseConfirmModal,
    onPagination,
    loading,
    deleteModalVisible,
  } = useDocumentList();

  return (
    <>
      <AlfredTableTemplate
        actionSection={
          <DocumentManagementButton
            onOk={onRefresh}
            loading={loading}
            onSave={onSave}
          />
        }
        columns={columns}
        data={data}
        onRowClick={onRowClick}
        pageCurrent={pageCurrent}
        pageSize={pageSize}
        totalPages={totalPages}
        onPagination={onPagination}
        isCharging={loading}
      />
      <ConfirmModal
        onCancel={onCloseConfirmModal}
        onClickMainButton={onConfirmDeleteDocument}
        visible={deleteModalVisible}
        loading={loading}
        title={deleteModalTitle}
        text={deleteModalText}
        mainButtonText={deleteModalMainButtonText}
        secondaryButtonText={deleteModalSecondaryButtonText}
      />
    </>
  );
};

export default DocumentListScreen;
